import axios from 'axios';
import { URL_ROLES_LIST } from './config';

export async function getRolesList() {
    const result = await axios.get(URL_ROLES_LIST);
    return result.data.data;
};

